<template>
    <div>
        <v-dialog
            v-model="uploadPhotoDialog"
            width="500"
        >
            <template v-slot:activator="{ on }">
                <v-btn
                    @click="uploadPhotoDialog === false ? $refs.fileInput.click() : ''"
                    v-on="on"
                    color="primary"
                >
                    Upload Internal Docs
                </v-btn>
            </template>
            <v-card>
                <input
                    ref="fileInput"
                    style="display: none"
                    type="file"
                    multiple
                    @change="onFileChange"
                >
                <v-card-title
                    class="headline"
                >
                    Upload Internal Docs
                </v-card-title>
                <v-card-text>
                    <div v-if="internalFiles.length === 0">
                        At least one photo required
                    </div>
                    <v-list
                        two-line
                        v-else
                    >
                        <v-list-tile
                            v-for="(file, index) in internalFiles"
                            :key="file.name"
                        >
                            <v-list-tile-content>
                                <v-list-tile-title>{{ file.name }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ file.size | bytesFormat }}</v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action
                                v-if="!file.fromPreviousSubmit"
                            >
                                <v-btn
                                    type="button"
                                    icon
                                    :disabled="file.fromPreviousSubmit"
                                    @click="internalFiles.splice(index, 1)"
                                >
                                    <v-icon size="18">
                                        fa-times
                                    </v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        flat
                        @click="uploadPhotoDialog = false"
                    >
                        Close
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        color="primary"
                        flat
                        @click="$refs.fileInput.click()"
                    >
                        Add More Files
                    </v-btn>
                    <v-btn
                        type="submit"
                        color="primary"
                        @click="onSubmit"
                    >
                        Upload
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import SnackBus from '../utils/buses/snackBus'
import _ from 'lodash'
import UserBus from '../utils/buses/userBus'
import { requestErrorMessage } from '../utils/constants/errors'

export default {
    props: {
        returnId: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            internalFiles: [],
            rules: {
                required: value => !!value || 'This field is required'
            },
            isSubmitting: false,
            uploadPhotoDialog: false
        }
    },
    methods: {
        onFileChange (e) {
            const files = e.target.files
            // ensure already chosen files are not duplicated in array
            this.internalFiles = _.unionBy(this.internalFiles, files, 'name')
            // reset input. this is needed for the case where a user selects a file,
            // deletes that file and tries to reselect the file. Without this
            // the @change event will not fire
            e.target.value = ''
        },
        onSubmit () {
            this.isSubmitting = true
            this.uploadPhotoDialog = false
            const formData = new FormData()
            formData.set('token', UserBus.token)
            formData.set('files', undefined)
            this.internalFiles.forEach(file => {
                formData.append('files', file)
            })
            axios.post('/api/returns/' + this.returnId + '/internalFiles', formData)
                .then(res => {
                    // reset files field
                    this.internalFiles = []
                    SnackBus.showMessage('Internal Document successfully uploaded', 'success')
                    this.$emit('refresh-data', true)
                })
                .catch(err => {
                    console.log('Add Internal Document Error', err)
                    SnackBus.showMessage(requestErrorMessage, 'error')
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
